import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { Input } from '../../input/input.js';
import { TimeFieldPickerIndex } from '../time-field-constants.js';
function TimeInput(props) {
    const { enabled, externalAction, index, interval, onBlur, onChange, onFocus, placeholder, readOnly, sensitiveData, strikethrough, time, valid, } = props;
    const onContainerFocus = (event) => {
        event.currentTarget.blur();
        event.target.blur();
    };
    const expression = index === TimeFieldPickerIndex.FROM ? 'tws.time-field.from' : 'tws.time-field.until';
    const inputClassName = classNames({
        'u-text-strikethrough': Boolean(strikethrough),
    });
    return (React.createElement("div", { className: "c-time-input__container", onFocus: onContainerFocus },
        interval
            ? React.createElement("div", { className: "c-time-input-title" }, MessageService.translate(expression))
            : null,
        React.createElement(Input, { className: inputClassName, enabled: enabled, externalAction: externalAction, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, readOnly: readOnly, sensitiveData: sensitiveData, valid: valid, value: time })));
}
export { TimeInput, };
//# sourceMappingURL=time-input.js.map